import { FC } from 'react'
import { Body, Header } from '@/components/Layout'

const AppLayout: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return (
    <div className="flex h-screen flex-col overflow-hidden bg-gray-50 dark:bg-dark-bg print:h-auto print:overflow-visible print:!bg-white">
      <Header />
      <Body>{children}</Body>
    </div>
  )
}

export default AppLayout
